/**
 * Content data for the Owner-Operator Software landing page
 * Requirements: 2.1-2.5, 3.1-3.3, 4.1-4.3, 5.1-5.3, 6.1-6.3, 7.1-7.4, 8.1-8.3, 9.1-9.2, 10.3
 */

export const ownerOperatorContent = {
  hero: {
    headline: "This Software Gives Owner-Operators Their Time Back",
    subheadline: "Automate daily tasks, reduce manual work, and free up hours every week so you can focus on real business problems, not admin work.",
    trustLine: "Built specifically for owner-operators who do everything themselves.",
    primaryCTA: "Get Free Access (First 100 Only)",
    secondaryCTA: "See How It Works"
  },
  pain: {
    title: "Owner-Operators Are Losing Time Where It Hurts Most",
    points: [
      { text: "Too many systems that don't talk to each other", icon: "disconnect" },
      { text: "Repeating the same tasks every day", icon: "repeat" },
      { text: "Paperwork, tracking, follow-ups eating into nights and weekends", icon: "paperwork" },
      { text: "No time left to solve bigger business problems", icon: "time" }
    ],
    bridgeStatement: "Time isn't just money, it's your ability to think, plan, and grow."
  },
  solution: {
    title: "One Software. Fewer Tasks. More Control.",
    capabilities: [
      { text: "Centralizes key owner-operator workflows", icon: "centralize" },
      { text: "Automates repetitive tasks", icon: "automate" },
      { text: "Keeps critical information organized and accessible", icon: "organize" },
      { text: "Reduces manual tracking and follow-ups", icon: "reduce" }
    ],
    outcomes: [
      { text: "Save hours every week", icon: "clock" },
      { text: "Fewer mistakes", icon: "check" },
      { text: "Less stress", icon: "calm" },
      { text: "More time to fix real operational problems", icon: "fix" }
    ]
  },
  timePayback: {
    title: "What Would You Do With 5–10 Hours Back Every Week?",
    examples: [
      { text: "Fix cash flow issues", icon: "money" },
      { text: "Improve operations", icon: "operations" },
      { text: "Spend time with family", icon: "family" },
      { text: "Take on more profitable work", icon: "profit" },
      { text: "Actually plan instead of reacting", icon: "plan" }
    ],
    positioningLine: "This software doesn't just save time, it gives you decision-making space."
  },
  urgency: {
    title: "Free for the First 100 Owner-Operators",
    points: [
      "Early adopters get full access at no cost",
      "Limited to first 100 to ensure proper onboarding and support",
      "No long-term commitment required"
    ],
    trustReinforcement: "We're rolling this out with real operators first to refine it around real-world use."
  },
  calendar: {
    title: "How It Works",
    steps: [
      { number: 1, text: "Book a short call using the calendar below" },
      { number: 2, text: "We confirm you're a good fit" },
      { number: 3, text: "Get access and start saving time" }
    ],
    ctaText: "Book My Free Access Call"
  },
  qualification: {
    title: "Is This for You?",
    forYou: [
      "Owner-operators",
      "Small business owners wearing multiple hats",
      "Operators tired of admin overload"
    ],
    notForYou: [
      "Large corporate teams",
      "Businesses that don't value time efficiency"
    ]
  },
  footerCTA: {
    headline: "Stop Spending Time on Work Software Should Be Doing",
    ctaText: "Claim My Free Spot (First 100)"
  },
  stickyCTA: {
    text: "Get Free Access"
  }
};
